module.exports = __webpack_public_path__ + "static/media/panel5.09e93366.png";